import { Spin } from 'antd';
import React, { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Axios from './axios';
import Dashboard from './dashboard';
import Ecommerce from './ecommerce';
import Features from './features';
import Gallery from './gallery';
import Pages from './pages';
// import Users from './kullanici';
import Widgets from './widgets';
import withAdminLayout from '../../layout/withAdminLayout';
import { setNavigate } from '../../utility/navigateHandler';

const Charts = lazy(() => import('./charts'));
const KnowledgeBase = lazy(() => import('../../container/pages/knowledgeBase/Index'));
const AllArticle = lazy(() => import('../../container/pages/knowledgeBase/AllArticle'));
const KnowledgeSingle = lazy(() => import('../../container/pages/knowledgeBase/SingleKnowledge'));
const Components = lazy(() => import('./components'));
const Task = lazy(() => import('../../container/task/Index'));
const Tickets = lazy(() => import('../../container/supportTicket/Index'));
const AddTicket = lazy(() => import('../../container/supportTicket/AddSupport'));
const TicketDetails = lazy(() => import('../../container/supportTicket/SupportTicketDetails'));
const Courses = lazy(() => import('../../container/course/Index'));
const CourseDetails = lazy(() => import('../../container/course/CourseDetails'));
const Import = lazy(() => import('../../container/importExport/Import'));
const Export = lazy(() => import('../../container/importExport/Export'));
const Muhendisler = lazy(() => import('../../container/muhendisler/Muhendis'));
const ToDo = lazy(() => import('../../container/toDo/ToDo'));
const Note = lazy(() => import('../../container/note/Note'));
// const Kanban = lazy(() => import('../../container/kanban/Index'));
const Contact = lazy(() => import('../../container/contact/Contact'));
const ContactGrid = lazy(() => import('../../container/contact/ContactGrid'));
const ContactAddNew = lazy(() => import('../../container/contact/AddNew'));
const Calendars = lazy(() => import('../../container/calendar/Calendar'));
const Projects = lazy(() => import('./proje'));
const Tanimlar = lazy(() => import('./tanimlar'));
const Gorevlendirm = lazy(() => import('./gorevlendirme'));
const Proje = lazy(() => import('./proje'));
const Myprofile = lazy(() => import('../../container/profile/myProfile/Index'));
const Chat = lazy(() => import('../../container/chat/ChatApp'));
const Inbox = lazy(() => import('../../container/email/Email'));
const Maps = lazy(() => import('./maps'));
const Editors = lazy(() => import('../../container/pages/Editor'));
const Icons = lazy(() => import('./icons'));
const Tables = lazy(() => import('./table'));
const Jobs = lazy(() => import('../../container/jobSearch/Jobs'));
const JobDetails = lazy(() => import('../../container/jobSearch/JobSearchDetails'));
const JobApply = lazy(() => import('../../container/jobSearch/JobApplication'));
const Firebase = lazy(() => import('./firebase'));
const NotFound = lazy(() => import('../../container/pages/404'));

const BilgiSayfalari = lazy(() => import('../../container/bilgiSayfalari/bilgiSayfalari'));
const Muhendis = lazy(() => import('./muhendis'));
const Kurum = lazy(() => import('./kurum'));
const Firma = lazy(() => import('./firma'));
const Kullanici = lazy(() => import('./kullanici'));
const DetaySayfalari = lazy(() => import('../../container/detaySayfalari/detaySayfalari'));
const Eimza = lazy(() => import('./eimza'));
const Management = lazy(() => import('./management'));
const AfetVeriAnalizi = lazy(() => import('./afetverianaliz'));
const LogKayitlari = lazy(() => import('./logkayitlari'));
const HaberlerDuyurular = lazy(() => import('./haberlerveduyurular'));
const Servisler = lazy(() => import('./servisler'));
const ReferansMain = lazy(() => import('../../container/referansNumarasi/referansMain'));

const Admin = React.memo(() => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const navigate = useNavigate();
  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route index path="/*" element={<Dashboard />} />
        <Route path="pages/*" element={<Pages />} />
        <Route path="gallery/*" element={<Gallery />} />
        <Route path="all-articles" element={<AllArticle />} />
        <Route path="knowledgeBase/*" element={<KnowledgeBase />} />
        <Route path="knowledgebaseSingle/:id" element={<KnowledgeSingle />} />
        <Route path="components/*" element={<Components />} />
        <Route path="charts/*" element={<Charts />} />
        <Route path="app/task/*" element={<Task />} />
        {/* <Route path="kullanicilar/*" element={<Users />} /> */}
        <Route path="app/support/tickets/*" element={<Tickets />} />
        <Route path="app/support/tickets/add" element={<AddTicket />} />
        <Route path="app/support/ticketDetails/:id" element={<TicketDetails />} />
        <Route path="app/course/courseDetails/:id" element={<CourseDetails />} />
        <Route path="app/course/*" element={<Courses />} />
        <Route path="importExport/import" element={<Import />} />
        <Route path="importExport/export" element={<Export />} />
        <Route path="app/to-do" element={<ToDo />} />
        <Route path="app/note/*" element={<Note />} />
        {/* <Route path="app/kanban/*" element={<Kanban />} /> */}
        <Route path="contact/list" element={<Contact />} />
        <Route path="contact/grid" element={<ContactGrid />} />
        <Route path="contact/addNew" element={<ContactAddNew />} />
        <Route path="app/calendar/*" element={<Calendars />} />
        <Route path="features/*" element={<Features />} />
        <Route path="project/*" element={<Projects />} />
        <Route path="tanimlar/*" element={<Tanimlar />} />
        <Route path="gorevlendirme/*" element={<Gorevlendirm />} />
        <Route path="afetverianalizi/*" element={<AfetVeriAnalizi />} />
        <Route path="logkayitlari/*" element={<LogKayitlari />} />
        <Route path="proje/*" element={<Proje />} />
        <Route path="profile/myProfile/*" element={<Myprofile />} />
        <Route path="ecommerce/*" element={<Ecommerce />} />
        <Route path="main/chat/*" element={<Chat />} />
        <Route path="email/*" element={<Inbox />} />
        <Route path="maps/*" element={<Maps />} />
        <Route path="editor" element={<Editors />} />
        <Route path="icons/*" element={<Icons />} />
        <Route path="tables/*" element={<Tables />} />
        <Route path="widgets/*" element={<Widgets />} />
        <Route path="app/jobs/*" element={<Jobs />} />
        <Route path="app/job/apply" element={<JobApply />} />
        <Route path="app/jobDetails/:id" element={<JobDetails />} />
        <Route path="firestore/*" element={<Firebase />} />
        <Route path="axios/*" element={<Axios />} />
        <Route path="BilgiSayfalari/*" element={<BilgiSayfalari />} />
        <Route path="DetaySayfalari/*" element={<DetaySayfalari />} />
        <Route path="muhendis/*" element={<Muhendis />} />
        <Route path="kurum/*" element={<Kurum />} />
        <Route path="firma/*" element={<Firma />} />
        <Route path="kullanici/*" element={<Kullanici />} />
        <Route path="Eimza/*" element={<Eimza />} />
        <Route path="management/*" element={<Management />} />
        <Route path="muhendisislemleri/muhendisler" element={<Muhendisler />} />
        <Route path="haberlerveduyurular/*" element={<HaberlerDuyurular />} />
        <Route path="servisler/*" element={<Servisler />} />
        <Route path="referansIslemleri" element={<ReferansMain />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
});

export default withAdminLayout(Admin);
